import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegisterMutationVariables = Types.Exact<{
  createUserInput: Types.CreateUserInput;
  stripeCardInput?: Types.InputMaybe<Types.CreateStripePaymentMethodInput>;
}>;


export type RegisterMutation = { __typename?: 'Mutation', Register: { __typename?: 'SessionEntity', accessToken?: string | null, headToURL?: string | null, selectedFirmAccount?: string | null, Entity?: { __typename?: 'Entity', id: string, Users?: { __typename?: 'UserEntity', email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, profilePhoto?: string | null } | null } | null } | null, RelatedFirms?: Array<{ __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null }> | null, UserFirmAccount?: { __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any, type: Types.FirmAccountType, businessType: Types.BusinessType, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, updateAt: any, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, lastName: string, firstName: string, createAt?: any | null, updateAt?: any | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null } | null, BusinessInformation?: { __typename?: 'BusinessInformationEntity', id?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null, ProgressStatuses?: Array<{ __typename?: 'ProgressStatusesEntity', id: string, firmAccountId: string, status: string, createAt: any, updateAt: any, underlyingStatus: Types.TaxYearStatus, index: number }> | null } | null, Entity?: { __typename?: 'Entity', id: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, profilePhoto?: string | null } | null } | null } | null, Users?: { __typename?: 'UserEntity', email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, firstName: string, lastName: string, birthday?: any | null, ssn?: string | null, profilePhoto?: string | null } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null } | null } };


export const RegisterDocument = gql`
    mutation Register($createUserInput: CreateUserInput!, $stripeCardInput: CreateStripePaymentMethodInput) {
  Register(createUserInput: $createUserInput, stripeCardInput: $stripeCardInput) {
    accessToken
    headToURL
    selectedFirmAccount
    Entity {
      id
      Users {
        email
        languageId
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
      }
    }
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        type
        businessType
        Users {
          id
          email
          createAt
          updateAt
          languageId
          UserInformation {
            id
            userId
            birthday
            lastName
            firstName
            createAt
            updateAt
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        BusinessInformation {
          id
          Phones {
            id
            value
            type
            createAt
            updateAt
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Entity {
        id
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            ssn
            profilePhoto
          }
        }
      }
      Users {
        UserInformation {
          id
          userId
          firstName
          lastName
          birthday
          ssn
          profilePhoto
        }
        email
        languageId
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      createUserInput: // value for 'createUserInput'
 *      stripeCardInput: // value for 'stripeCardInput'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const namedOperations = {
  Mutation: {
    Register: 'Register'
  }
}